import { render, staticRenderFns } from "./artComponent.vue?vue&type=template&id=95c48ca8&scoped=true&"
import script from "./artComponent.vue?vue&type=script&lang=js&"
export * from "./artComponent.vue?vue&type=script&lang=js&"
import style0 from "./artComponent.vue?vue&type=style&index=0&id=95c48ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c48ca8",
  null
  
)

export default component.exports